import moment from "moment";
import React from "react";

export const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
  const containerStyle = {
    margin: '0 5px',
  };

  const renderYearsOptions = () => {
    const yearsRange = 20;
    const options = [];

    for (let i = 0; i < yearsRange; i++) {
      const year = moment().year() - i;
      options.push(<option key={i} value={year}>{year}</option>);
    }

    return options;
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div>
        <select className="DateRangePicker_select" value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
          {moment.months().map((label, value) => (
            <option key={label + Math.random(3)} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div style={containerStyle}>
        {}
        <select className="DateRangePicker_select" value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
          {renderYearsOptions()}
        </select>
      </div>
    </div>
  );
};